<!-- eslint-disable vue/no-v-html -->
<template>
    <section id="part-detail-results">
        <a id="part-detail-stock-and-price-link" class="part-detail-section-link !-top-[300px]" tabindex="-1"></a>
        <h2 class="part-page-heading">{{ $t("PartDetail.ResultsHeading") }}</h2>
        <div class="table-scroll">
            <table v-if="hasResults" id="ExactMatchesTable" class="table table-search-results">
                <thead>
                    <tr>
                        <th v-html="$t('Search.AuthorizedDistributor')"></th>
                        <th v-hidden="'xs,sm,md,lg-1270'">{{ $t("Search.RoHS") }}</th>
                        <th v-hidden="'xs'">{{ $t("Global.Datasheet") }}</th>
                        <th v-hidden="'xs,sm,md'">{{ $t("Search.Supplier_Number") }}</th>
                        <th v-hidden="'xs,sm,md'">{{ $t("Search.PackagingHeader") }}</th>
                        <PartStockHeader :notification="props.partResult.PartNotification">
                            <!-- for non-js clients -->
                            <div>
                                <span>{{ $t("Global.Stock") }}</span>
                                <button class="btn stock-alert" :title="$t('Notifications.CreateProductNotification')">
                                    <i class="fas fa-circle-plus"></i>
                                    <i class="fas fa-bell"></i>
                                </button>
                            </div>
                        </PartStockHeader>
                        <th>{{ $t("Search.Pricing") }}</th>
                        <th class="w-px print:hidden"></th>
                    </tr>
                </thead>
                <tbody>
                    <PartResultsRow
                        v-for="result of results"
                        :key="result.SortOrder"
                        v-model:expanded="expanded[result.SortOrder]"
                        :show-child="expanded[result.ParentSortOrder]"
                        :item="result"
                        :has-children="hasChildren(result)"
                        :show-rohs="true"
                        :click-hash="props.partResult.PartClickHash"
                        :click-data-source="ANALYTICS_SOURCE.PART_DETAIL" />
                </tbody>
            </table>
            <div v-if="!hasResults" v-html="$t('Search.MessageNoMatchesHeader')" />
        </div>
        <p>
            <strong>
                <a :href="localePath('/search/' + props.partResult.PartNumber)" :title="seeMoreLinkText">
                    {{ seeMoreLinkText }}
                </a>
            </strong>
        </p>
    </section>
</template>
<script setup>
const props = defineProps({ partResult: { type: Object, required: true } });
const localePath = useLangPath();
const { t } = useI18n();
const expanded = ref({});

const hasResults = computed(() => props.partResult && props.partResult.Results && props.partResult.Results.length);
const seeMoreLinkText = computed(() => t("PartDetail.SeeAllAuthorizedResults", [props.partResult.DisplayPartNumber]));

const results = computed(() => {
    if (!props.partResult || !props.partResult.Results) {
        return [];
    }

    const sortedResults = [...props.partResult.Results].sort((a, b) => {
        return new String(a.SortOrder).localeCompare(b.SortOrder);
    });

    SearchHelpers.calculatePartsDisplayIndex(sortedResults);

    return sortedResults;
});

const hasChildren = (item) => SearchHelpers.distributorResultHasChildren(props.partResult.Results, item);
</script>
